import { CommonModule, NgOptimizedImage, ViewportScroller } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import { AdsComponent } from '../../components/ads/ads.component';
import { CommonEventListComponent } from '../../components/common-event-list/common-event-list.component';
import { CommonNewsComponent } from '../../components/common-news/common-news.component';
import { CommonXdgeStoreComponent } from '../../components/common-xdge-store/common-xdge-store.component';
import { FeaturedFeedComponent } from '../../components/featured-feed/featured-feed.component';
import { HomeBannerComponent } from '../../components/home-banner/home-banner.component';
import { TabToTopComponent } from '../../components/tab-to-top/tab-to-top.component';
import { ViewStorePopupComponent } from '../../shared/popups/view-store-popup/view-store-popup.component';
import { BrowserStorageService } from '../../shared/services/common/browser-storage.service';
import { ApiCallsService } from '../../shared/services/network/api-calls.service';
import { UserService } from '../../shared/services/user.service';
import { LIMIT, MAX_SIZE } from '../../utils/constants';
import { api } from '../../utils/endpoints';
import { fileDirectories } from '../../utils/view-settings';

@Component({
  selector: 'app-home',
  imports: [
    CommonModule,
    HomeBannerComponent,
    CommonEventListComponent,
    CommonXdgeStoreComponent,
    FeaturedFeedComponent,
    // AdsComponent,
    CommonNewsComponent,
    RouterLink,
    TabToTopComponent,
    NgOptimizedImage,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit {
  @ViewChild('childContainer', { read: ViewContainerRef }) container!: ViewContainerRef;
  userDetail: any;
  public userLoggedIn = false;
  public expertUser = false;
  sportList = [];
  feedList = 0;
  featuredFeedList = 0;
  eventList = 0;
  xdgeStoreList: any = [];
  xdgeNewsList: any = 0;
  bannerList: any = [];
  topSportSequence: any = [];
  pagination = { limit: LIMIT, maxSize: MAX_SIZE, skip: 0, totalItems: 0, row: 0, text: 'Loading...' };

  fileDirectoriesPath: any = fileDirectories.profile;
  constructor(
    private _apiService: ApiCallsService,
    private changeDetectorRef: ChangeDetectorRef,
    private _router: Router,
    private _storageService: BrowserStorageService,
    private _userService: UserService,
    private _ngbModal: NgbModal,
    private viewportScroller: ViewportScroller,
    private route: ActivatedRoute,
  ) {
    if (this._storageService.getBrowser()) {
      this._router.events.subscribe((event: any) => {
        if (event instanceof NavigationEnd) {
          this.viewportScroller.scrollToPosition([0, 0]);
        }
      });
      if (this._storageService.getBrowser()) {
        // Inject Banner Data only on Client Side
        this.bannerList = this.route.snapshot.data['data']['bannerData'];
      }
    }
  }

  ngOnInit(): void {
    if (this._storageService.getBrowser()) {
      this._userService.user.subscribe((user) => {
        if (user) {
          this.userDetail = user;
          this._getUserData(this.userDetail);
          this.changeDetectorRef.detectChanges();
        }
        this.getTopSport();
      });
    }
  }
  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    if (!this.userDetail) {
      this.loadChild();
    }
  }

  async loadChild() {
    this.container.clear();
    const { EvaluateSkillsComponent } = await import('../../components/evaluate-skills/evaluate-skills.component');
    this.container.createComponent(EvaluateSkillsComponent);
  }

  private _getUserData(userDetail: any): void {
    let webDetails = userDetail;
    if (webDetails) {
      this.userLoggedIn = true;
    } else {
      this.userLoggedIn = false;
    }
    if (webDetails?.registrationReason == 1 || webDetails?.isExpert) {
      this.expertUser = true;
    } else {
      this.expertUser = false;
    }
  }
  viewAll(path: any, entity: any) {
    this.userDetail = this._storageService.getItem('userDetail');
    if (this.userDetail) {
      this._router.navigate([path]);
    } else {
      let modalRef = this._ngbModal.open(ViewStorePopupComponent, {
        scrollable: false,
        backdrop: 'static',
        keyboard: false,
        size: 'filterPopup',
        centered: true,
      });
      if (entity) {
        modalRef.componentInstance.entity = entity;
      }
    }
  }

  onExploreClick() {
    let modalRef = this._ngbModal.open(ViewStorePopupComponent, {
      scrollable: false,
      backdrop: 'static',
      keyboard: false,
      size: 'filterPopup',
      centered: true,
    });
  }
  getTopSport() {
    this._apiService.post(api._sportListing, { topSportSequence: true, limit: 5 }).subscribe({
      next: (res: any) => {
        this.topSportSequence = res.data.rows;
      },
      error: (error: any) => console.log(error),
    });
  }

  scrollToEvaluateSkills() {
    this.viewportScroller.scrollToAnchor('evaluateSkillsSection');
  }
}
